import { Injectable } from '@angular/core';
import {
  DataModel,
  MetaModel,
  WidgetModel,
} from 'common/models/utility-models/base-model';
import { FormWidgetService } from '../form-widget.service';
import { RegisterFormDataService } from 'common/services/data-services/admin/register/register-data.service';
import { API_URL } from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import { SystemService } from 'common/services/core-services/system.service';
import { RegisterModel } from 'common/models/page-models/register/register-final-model/register-data-model';
import { RegisterMetaModel } from 'common/models/page-models/register/register-final-model/register-form-meta-model';
import { DistrictService } from 'common/services/data-services/custom-service/district.service';
import { DepartmentListDataService } from 'common/services/data-services/custom-service/department-list-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { DistrictDataService } from 'common/services/data-services/custom-service/district-data.service';
import { data } from 'jquery';
import { DepartmentListRegisterDataService } from 'common/services/data-services/custom-service/departmentListRegister.service';

@Injectable({
  providedIn: 'root',
})
export class RegisterFormWidgetService extends FormWidgetService<RegisterModel> {
  constructor(
    protected ds: RegisterFormDataService,
    private ss: SystemService,
    private districtService: DistrictDataService,
    private department: DepartmentListRegisterDataService,
    private stateList: stateListDataService
  ) {
    super(ds);
  }
  getMetaModel(): MetaModel {
    const meta = new RegisterMetaModel();
    return meta.getMetaModel();
  }

  override prepareMetaModel(
    dataModel: DataModel,
    metaModel: RegisterMetaModel,
    routeData: WidgetModel
  ): Promise<RegisterMetaModel> {
    return new Promise<RegisterMetaModel>((resolve, reject) => {
      // this.districtService.filteredDistrictDetails = this.districtService.districtDetails;
      //       metaModel.properties.step1.properties['district'].options = this.districtService.filteredDistrictDetails;

      // this.ds.setSystemServiceData('state_List', API_URL.stateList, ' ', 'detail').then((data)=>{
      //     metaModel.properties.step1.properties['stateId'].options = data.detail
      //     metaModel.properties.step4.properties['collageStateId'].options = data.detail

      //     resolve(metaModel);
      // }).catch((err)=>{
      //     reject(err)

      // })
      // this.ds.setSystemServiceData('department_name', API_URL.getDepartmentTypeList, ' ', 'detail').then((data)=>{
      //     metaModel.properties.step4.properties['branchId'].options = data.detail

      //     resolve(metaModel);
      // }).catch((err)=>{
      //     reject(err)

      // })

      
      this.districtService
        .postData({
          state_id: 258,
        })
        .then((data) => {
          // console.log('district',data.details);
          metaModel.properties.step1.properties['district_id'].options =
            data.details;
        });

      this.stateList.postData({}).then((data) => {
        metaModel.properties.step1.properties['stateId'].options = data.details;
        metaModel.properties.step4.properties['collageStateId'].options =
          data.details;
      });
      this.department.postData({}).then((data) => {
        metaModel.properties.step4.properties['branchId'].options =
          data.details;
      });
      resolve(metaModel);
    }).catch((err) => {
      return err;
    });
  }

  postDataToApiWidget(url: string, body: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.ds
        .postDataToApi(url, body)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
